/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      const copyLinkButton = $( '.social-share__item.share-link' );

      if ( copyLinkButton.length ) {
        copyLinkButton.on( 'click', function() {
          const url = $( this ).find( 'button' ).attr( 'data-url' );
          const copiedText = $( this ).find( '.copied-text' );

          console.log( url );
          console.log( copiedText );

          // Copy to clipboard
          navigator.clipboard.writeText( url ).then( function() {
            // Show "Copied" message
            copiedText.addClass( '!opacity-100' );

            // Hide after 2 seconds
            setTimeout( function() {
              copiedText.removeClass( '!opacity-100' );
            }, 2000 );
          } ).catch( function( err ) {
            console.error( 'Could not copy text: ', err );
          } );
        } );
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'blog', COMPONENT );
} )( app );
